import React, { useEffect, useState } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useAuthUser, useAuthAccountId, useTheme } from '@nbx/frontend-helpers/subscribe';
import SEO from 'components/shared/SEO';
import Orders from 'routes/Orders';
import OrderDetails from 'routes/OrderDetails';
import Main from 'components/app/Main';
import { NBXAdmins, NBXMarkets, NBXAccounts, NBXPayments, NBXWithdrawals } from 'services';
import styles from './styles.module.scss';

const microapps = window.MICROFRONTENDS_CONFIG;
function App() {
  const user = useAuthUser();
  const accountId = useAuthAccountId();
  const theme = useTheme();
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    window
      .GET_API_CONFIG()
      .then(config => {
        NBXAdmins.init(config.api.admins);
        NBXMarkets.init(config.api.markets);
        NBXAccounts.init(config.api.accounts);
        NBXPayments.init(config.api.payments);
        NBXWithdrawals.init(config.api.withdrawals);

        setConfigured(true);
        const spinner = document.querySelector('#microfrontend_hook > .spinner');
        if (spinner) {
          spinner.parentNode.removeChild(spinner);
        }
      })
      .catch(error => {
        throw new Error('Error loading configuration file: ', error);
      });
  }, []);

  if (!configured) return null;

  return (
    <HelmetProvider>
      <nbx-theme-provider theme={theme}>
        <Router history={window.HISTORY}>
          <SEO title="Orders" />
          <Main>
            <div className={styles.routeWrapper}>
              <Switch>
                {!!user && (
                  <Route
                    path={window.GET_LOCALE_PATHS(microapps.routes.orderDetails.path)}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    component={props => <OrderDetails {...props} user={user} accountId={accountId} />}
                  />
                )}
                {!!user && (
                  <Route
                    path={window.GET_LOCALE_PATHS(microapps.routes.orders.path)}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    component={props => <Orders {...props} user={user} accountId={accountId} />}
                  />
                )}
              </Switch>
            </div>
          </Main>
        </Router>
      </nbx-theme-provider>
    </HelmetProvider>
  );
}

export default App;
